import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Time from '../time/Time';
import KickStrengthInput from '../kick-counter/KickStrengthInput';
import DebounceButton from '../button/DebounceButton';
import { KickCounterContext } from '../../context/KickCounterContext';
import styles from './EndSessionModal.module.css';
import sharedButtonStyles from '../button/Button.module.css';
import { COUNTER_MODE, ROUTE } from '../../constants/constants';

export default function EndSessionModel({ userEndSession }) {
  const {
    kickList, time, counterMode, setSessionEndTime,
  } = useContext(KickCounterContext);

  useEffect(() => {
    setSessionEndTime(new Date());
  }, []);

  return (
    <div className={styles.modalContainer}>
      { counterMode === COUNTER_MODE.KICK && !userEndSession && (
      <div className={styles.movementContainer}>
        You have reached
        {' '}
        <span>10</span>
        {' '}
        movements!
      </div>
      )}
      { counterMode === COUNTER_MODE.TIME && !userEndSession && (
      <div className={styles.movementContainer}>
        You have reached
        {' '}
        <span>30 minutes!</span>
      </div>
      )}

      { (counterMode === COUNTER_MODE.TIME || userEndSession) && (
      <div className={styles.sessionContainer}>
        Total movements counted:&nbsp;
        <span>{kickList.length}</span>
        &nbsp;Movements
      </div>
      )}
      { (counterMode === COUNTER_MODE.KICK || userEndSession) && (
      <div className={styles.sessionContainer}>
        Session time:&nbsp;
        <span>
          <Time time={time} />
        </span>
      </div>
      )}

      <div>Add the strength of your movements during this session</div>
      <KickStrengthInput />
      <div className={styles.buttonContainer}>
        <Link to={ROUTE.SUMMARY}>
          <DebounceButton
            className={classNames(
              styles.saveButton,
              sharedButtonStyles.FCButton,
              sharedButtonStyles.long,
            )}
            onClick={() => {}}
          >
            Save this session
          </DebounceButton>
        </Link>
      </div>
    </div>
  );
}
